<template>
  <div>
    <Nav></Nav>
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <h1>Grupos de Extras</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button variant="primary" @click="$router.push('/product-extra-group')">Crear Grupo de Extras</b-button>
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col>
          <b-card>
            <b-row>
              <b-col>
                <h3>Filtros:</h3>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Buscar:">
                  <b-form-input type="search" v-model="search" @keyup="page = 1" debounce="500"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          Hay {{ extraGroups.length }} registros
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table small :filter="search" striped hover :items="extraGroups" :fields="tableFields"
            responsive="md" :per-page="byPage" :current-page="page">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Cargando...</strong>
              </div>
            </template>
            <template #cell(product_id)="data">
              {{ getProductName(data.item.product_id) }}
            </template>
            <template #cell(status)="data">
              <b-badge pill v-if="data.item.status == 1" variant="success">Activo</b-badge>
              <b-badge pill v-else variant="danger">Inactivo</b-badge>
            </template>
            <template #cell(actions)="data">
              <b-button-group>
                <b-button size="sm" variant="warning" @click="$router.push('/product-extra-group/' + data.item.id)">Editar</b-button>
                <b-button size="sm" variant="danger" @click="deleteGroup(data.item.id)">Eliminar</b-button>
              </b-button-group>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination v-model="page" :total-rows="extraGroups.length" :per-page="byPage"
            aria-controls="my-table"></b-pagination>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Nav from "../components/Nav.vue";
import axios from "axios";

export default {
  name: "ProductExtraGroups",
  components: { Nav },
  data() {
    return {
      byPage: 20,
      page: 1,
      search: "",
      extraGroups: [],
      products: [],
      tableFields: [
        { key: "id", label: "ID", sortable: true, sortDirection: "desc", class: "align-middle" },
        { key: "product_id", label: "Producto", sortable: true, class: "align-middle" },
        { key: "name", label: "Nombre del Grupo", sortable: true, class: "align-middle" },
        { key: "min_selection", label: "Min Seleccion", sortable: true, class: "align-middle" },
        { key: "max_selection", label: "Max Seleccion", sortable: true, class: "align-middle" },
        { key: "status", label: "Estado", sortable: true, class: "align-middle" },
        { key: "actions", label: "Acciones", class: "align-middle" },
      ],
    };
  },
  mounted() {
    this.loadGroups();
    this.loadProducts();
  },
  methods: {
    loadGroups() {
      let that = this;
      axios
        .get("/product/extragroups")
        .then(function (response) {
          that.extraGroups = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    loadProducts() {
      let that = this;
      axios
        .get("/products")
        .then(function (response) {
          that.products = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getProductName(id) {
      let product = this.products.find((p) => p.id == id);
      return product ? product.id + " " + product.ndescription : id;
    },
    deleteGroup(id) {
      if (!confirm("¿Estás seguro de eliminar este grupo de extras?")) return;
      let that = this;
      axios
        .delete("/product/extragroup/" + id)
        .then(function () {
          that.makeToast("Exito", "Grupo eliminado", "success");
          that.loadGroups();
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>
